import gql from "graphql-tag"

export default gql`
  query allAlbums($user: String!) {
    allAlbums: albums(
      filter: {
        user: { username: { equatTo: $user } }
        hidden: { equalTo: false }
      }
    ) {
      id
      slug
      title
      description
      keyValues {
        id
        key {
          id
          name
        }
        value
      }
      tags {
        id
        name
      }
      slides(orderBy: POS_ASC, filter: { hidden: { equalTo: false } }) {
        id
        order: pos
        file: image {
          id
          url
          secret
        }
        videoUrl
        width
        height
        title
        description
        slideTags: tags {
          id
          name
        }
        slideKeyValues: keyValues {
          id
          slideKey {
            id
            name
          }
          value
        }
      }
    }
  }
`
